module.exports = __webpack_public_path__ + "img/SXM.62824811.svg";